import { useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { pathPatternMatch, useSearch, queryToSearch } from './makeNav';
import { without } from 'lodash';

export default memo(function NavValue({ path, name, value = true, onValue, multi, children }) {
  const { pathname } = useLocation();
  const query = useSearch();

  const queryValueAsArray = multi && query[name]
    ? tryParse(query[name])
    : [];
  const match = name
    ? multi
      ? queryValueAsArray.includes(value)
      : value === '*'
        ? Boolean(query[name])
        : query[name] === value
    : pathPatternMatch(pathname, path);
  const to = name
    ? multi
      ? match
        ? `${pathname}?${queryToSearch({ ...query, [name]: encodeURIComponent(JSON.stringify(without(
          queryValueAsArray,
          value,
        )))})}`
        : `${pathname}?${queryToSearch({ ...query, [name]: encodeURIComponent(JSON.stringify([
          ...queryValueAsArray,
          value,
        ]))})}` 
      : `${pathname}?${queryToSearch({ ...query, [name]: value })}`
    : pathname;

  useEffect(() => {
    try {
      if (onValue) {
        onValue(match);
      }
    } catch (e) { /* empty */ }
  }, [onValue, name, query[name], match]);
  
  if (!(typeof(children) === 'function')) {
    return null;
  }

  return children({ match, to, queryValueAsArray });
});

function tryParse(str) {
  try {
    return JSON.parse(str);
  } catch {
    return [];
  }
}